import { render, staticRenderFns } from "./CoShareInMessenger.vue?vue&type=template&id=24e5a0b5&scoped=true&"
import script from "./CoShareInMessenger.vue?vue&type=script&lang=ts&"
export * from "./CoShareInMessenger.vue?vue&type=script&lang=ts&"
import style0 from "./CoShareInMessenger.vue?vue&type=style&index=0&id=24e5a0b5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e5a0b5",
  null
  
)

export default component.exports